import { render } from "./DocumentInput.vue?vue&type=template&id=03d86106&ts=true"
import script from "./DocumentInput.vue?vue&type=script&lang=ts"
export * from "./DocumentInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__